import { ApiError, OldApiResult } from '@models/api';
import { UseQueryOptions, useQuery } from '@hooks/react-query';

import { FeatureSettingsResponse } from '../models';

function useRGetDigiSignFeatureSettings(
  options: UseQueryOptions<
    OldApiResult<FeatureSettingsResponse>,
    ApiError
  > = {},
) {
  return useQuery<OldApiResult<FeatureSettingsResponse>, ApiError>({
    queryKey: ['digisign/v1/feature-setting/status'],
    enabled: true,
    ...options,
  });
}

export default useRGetDigiSignFeatureSettings;
